import { render } from "./PaymentMethodsList.vue?vue&type=template&id=f45da754&ts=true"
import script from "./PaymentMethodsList.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodsList.vue?vue&type=script&lang=ts"

import "./PaymentMethodsList.vue?vue&type=style&index=0&id=f45da754&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__